import { AppCodeArea, AppPageHeader } from 'components/ui';

import { observer } from 'mobx-react-lite';
import { t } from 'utilities/TranslationUtils';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const SharedSessionsPage = observer(() => {
  const params = useParams<{ shareCode: string }>();

  useEffect(() => {
    var meta = document.createElement('meta');
    meta.name = 'robots';
    meta.setAttribute('content', 'noindex');
    document.getElementsByTagName('head')[0].appendChild(meta);
  }, []);

  return (
    <div>
      <AppPageHeader title={t('common.shared_sessions_page')} />
      <AppCodeArea title={t('common.shared_code')} content={params.shareCode} />
    </div>
  );
});

export default SharedSessionsPage;
